import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { loadPriceComparisonFlags, visibleTabs } from '../utils/priceComparison';

// Las pestañas de "Comparativa de precios". Van arriba de las dos pantallas (competencia y
// proveedor) para pasar de una a otra; sólo se ofrece la que tiene su interruptor encendido.
class PriceComparisonTabs extends Component {

    constructor(props) {
        super(props);
        this.state = { flags: null };
        this._mounted = false;
    }

    componentDidMount() {
        this._mounted = true;
        loadPriceComparisonFlags().then((flags) => { if (this._mounted) this.setState({ flags }); });
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    render() {
        const tabs = visibleTabs(this.state.flags, this.props.active);
        // Con una sola pantalla encendida no hay entre qué elegir.
        if (tabs.length < 2) {
            return null;
        }
        return (
            <ul className="nav nav-tabs mb-3">
                {tabs.map((tab) => (
                    <li className="nav-item" key={tab.id}>
                        <Link className={`nav-link ${tab.id === this.props.active ? 'active' : ''}`} to={tab.to}>
                            {tab.label}
                        </Link>
                    </li>
                ))}
            </ul>
        );
    }
}

export default PriceComparisonTabs;
